import PlayerCard from './player-card';

export default PlayerCard;
